import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRegistration } from '../store/RegistrationContext';
import { registrationActionTypes } from '../store/registrationReducer';

const UserProfile = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useRegistration();
  const { isAuthenticated, user } = state.auth;
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    dispatch({ type: registrationActionTypes.LOGOUT });
    setShowDropdown(false);
    navigate('/retreat');
  };

  const getUserInitials = () => {
    const userData = user?.userData || user;
    const firstName = userData?.user_First_Name || userData?.User_First_Name || '';
    const lastName = userData?.user_Last_Name || userData?.User_Last_Name || '';
    
    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    }
    
    const email = userData?.user_Email || userData?.User_Email || '';
    if (email) {
      return email.split('@')[0].split('.').map(part => part.charAt(0).toUpperCase()).join('').slice(0, 2);
    }
    
    return 'U';
  };

  const getUserName = () => {
    const userData = user?.userData || user;
    const firstName = userData?.user_First_Name || userData?.User_First_Name || '';
    const lastName = userData?.user_Last_Name || userData?.User_Last_Name || '';
    
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    }
    
    const email = userData?.user_Email || userData?.User_Email || '';
    if (email) {
      return email.split('@')[0].split('.').map(part => 
        part.charAt(0).toUpperCase() + part.slice(1)
      ).join(' ');
    }
    
    return 'User';
  };

  const getUserEmail = () => {
    const userData = user?.userData || user;
    return userData?.user_Email || userData?.User_Email || '';
  };

  if (!isAuthenticated) {
    return (
      <button
        onClick={() => navigate('/login')}
        className="flex items-center gap-2 bg-white hover:bg-gray-50 text-gray-700 font-semibold py-2 px-4 rounded-full border-2 border-gray-200 transition shadow-sm hover:shadow-md text-sm"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
        </svg>
        Login
      </button>
    );
  }

  return (
    <div className="relative">
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        className="flex items-center gap-2 hover:bg-gray-50 transition-colors duration-200 rounded-full px-2 py-1"
      >
        <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md hover:shadow-lg transition-shadow duration-200">
          {getUserInitials()}
        </div>
        <svg 
          className={`w-4 h-4 text-gray-600 transition-transform ${showDropdown ? 'rotate-180' : ''}`} 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {showDropdown && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-30" 
            onClick={() => setShowDropdown(false)}
          ></div>

          {/* Dropdown Menu */}
          <div className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-2xl border-2 border-gray-100 z-40 overflow-hidden">
            {/* User Info */}
            <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-4 border-b-2 border-gray-100">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  {getUserInitials()}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-gray-900 text-sm break-words">
                    {getUserName()}
                  </p>
                  <p className="text-xs text-gray-600 break-all">
                    {getUserEmail()}
                  </p>
                </div>
              </div>
            </div>

            {/* Menu Items */}
            <div className="py-2">
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-red-50 transition text-red-600 font-semibold"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Logout
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UserProfile;
